import { render, staticRenderFns } from "./MouserProductSheetSpecs.vue?vue&type=template&id=d823e89c&scoped=true&lang=pug&"
import script from "./MouserProductSheetSpecs.vue?vue&type=script&lang=js&"
export * from "./MouserProductSheetSpecs.vue?vue&type=script&lang=js&"
import style0 from "./MouserProductSheetSpecs.vue?vue&type=style&index=0&id=d823e89c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d823e89c",
  null
  
)

export default component.exports